import { PayloadAction, Slice, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { User, UserState } from './user.types';
import { Permissions } from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';

export const initialState: UserState = {
    user: null,
    permissions: undefined,
};

export const userSlice: Slice<UserState> = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<User | null>) => {
            state.user = action.payload;
        },
        setUserPermissions: (state, action: PayloadAction<Permissions>) => {
            state.permissions = action.payload;
        },
        logout: (state) => {
            state.user = null;
            state.permissions = undefined;
        },
        setNewToken: (state, action: PayloadAction<string>) => {
            if (state.user) {
                state.user.accessToken = action.payload;
            }
        },
    },
});

export const { setUser, setUserPermissions, logout, setNewToken } =
    userSlice.actions;
export const selectCurrentUser = (state: RootState) => state.user.user;
export const selectUserPermissions = (
    state: RootState
): Permissions | undefined => state.user.permissions;
export default userSlice.reducer;
